// Date Difference Tool — days/weeks/months between two dates, plus countdown.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const dateDifferenceTool: Tool = {
  id: "date-difference",
  name: () => m.dd_tool_name(),
  description: () => m.dd_tool_description(),
  icon: "📆",
  basePath: "/date-difference",
  status: "stable",
  tags: ["date", "days", "countdown", "calculator"],
  pages: [
    {
      name: () => m.dd_nav_main(),
      path: "/date-difference",
      description: () => m.dd_nav_main_desc(),
      icon: "📆",
    },
  ],
};
